<template>
  <div class="row">
    <div :class="markers.length > 0 ? 'col-md-8 d-none d-md-block' : 'col-md-12'">
      <div class="card">
        <div class="card-header pb-0">
          <div class="d-flex align-items-center">
            <h4 class="mb-0">Incidencias</h4>
          </div>
        </div>
        <div class="row container-fluid">
          <div class="card-body px-0 pt-0 pb-2 ">
            <div class="table-responsive p-0 col-md-12">
              <table class="table align-items-center mb-0" id="my-table-incidences">
                <thead>
                  <tr>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 text-center">
                      Usuario
                    </th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 text-center ">
                      Descripción de la incidencia
                    </th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 text-center">
                      Estado
                    </th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 text-center">
                      Fecha
                    </th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 text-center">
                      Hora
                    </th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 text-center">
                      Acciones
                    </th>
                  </tr>
                </thead>
                <tbody v-if="incidences.length !== 0">
                  <tr v-for="(incidence) in incidences" :key="incidence.id">
                    <!-- <td>
                      <div class="d-flex justify-content-center align-items-center">
                        <div class="d-flex justify-content-start">
                          <img src="/user.png" class="avatar avatar-sm me-3" alt="incidence1" />
                          <div>
                            <h6 class="mb-0 text-sm">{{ `${incidence.user.name} ${incidence.user.last_name}` }}</h6>
                            <p class="text-xs text-secondary mb-0">{{ incidence.user.phone }}</p>
                          </div>
                        </div>
                      </div>
                    </td> -->
                    <td>
                      <div class="d-flex flex-column">
                        <h5 class="mb-0 text-sm ">
                          {{ `${incidence.user.name}` }}
                        </h5>
                        <h5 class="mb-0 text-sm text-wrap">
                          {{ `${incidence.user.last_name}` }}
                        </h5>
                      </div>
                      <h6 class="text-xs text-secondary mb-0">{{ incidence.user.phone }}</h6>
                    </td>
                    <td class="align-middle text-center">
                      <small>{{ incidence.kind ? incidence.kind :
                        '-' }}</small>
                    </td>
                    <td class="align-middle text-center">
                      <div class="d-flex justify-content-center align-items-center">
                        <div class="dropdown pe-3">
                          <button class="btn btn-link mb-0" type="button" @click="openDrop(incidence.id)">
                            <span class="badge badge-pill badge-danger estatus" v-if="incidence.status == 1">Nuevo <i
                                class="fa fa-chevron-down" v-if="!incidence.openMenu"></i><i v-else
                                class="fa fa-chevron-up"></i> </span>
                            <span class="badge badge-pill badge-warning estatus" v-if="incidence.status == 2">Activo <i
                                class="fa fa-chevron-down" v-if="!incidence.openMenu"></i><i v-else
                                class="fa fa-chevron-up"></i> </span>
                            <span class="badge badge-pill badge-warning estatus" v-if="incidence.status == 3">En camino <i
                                class="fa fa-chevron-down" v-if="!incidence.openMenu"></i><i v-else
                                class="fa fa-chevron-up"></i> </span>
                            <span class="badge badge-pill badge-success estatus" v-if="incidence.status == 4">Resuelto <i
                                class="fa fa-chevron-down" v-if="!incidence.openMenu"></i><i v-else
                                class="fa fa-chevron-up"></i> </span>
                            <!-- <span class="badge badge-pill badge-secondary estatus" v-if="incidence.status == 4">Cancelado
                              <i class="fa fa-chevron-down" v-if="!incidence.openMenu"></i><i v-else
                                class="fa fa-chevron-up"></i> </span> -->
                          </button>
                          <Transition name="slide-fade">
                            <div class="" v-if="incidence.openMenu">
                              <!-- <a class="cursor-pointer dropdown-item" @click="changeStatus(incidence.id, 1)">Nuevo</a> -->
                              <a class="cursor-pointer dropdown-item" @click="changeStatus(incidence.id, 2)">Activo</a>
                              <a class="cursor-pointer dropdown-item" @click="changeStatus(incidence.id, 3)">En camino</a>
                              <!-- <a class="cursor-pointer dropdown-item" @click="changeStatus(incidence.id, 3)">Resuelto</a> -->
                              <a class="cursor-pointer dropdown-item" @click="changeStatus(incidence.id, 4)">Resuelto</a>
                            </div>
                          </Transition>
                        </div>
                      </div>
                    </td>
                    <td >
                      <div class="d-flex justify-content-center align-items-center">
                        <p class="text-xs font-weight-bold mb-0 pe-3">{{ dateSort(incidence.date) }}</p>
                      </div>
                    </td>
                    <td>
                      <div class="d-flex justify-content-center align-items-center">
                        <p class="text-xs font-weight-bold mb-0 pe-3">{{ timeSort(incidence.date) }}</p>
                      </div>
                    </td>
                    <td>
                      <div class="d-flex justify-content-center align-items-center me-3">
                        <button class="btn btn-link text-dark  px-3 mb-0" @click="openLocation(incidence.id)">
                          <i class="fas fa-map-marker-alt text-dark me-2" aria-hidden="true"></i>
                          Ver ubicación
                        </button>
                        <button @click="showAlertDelete(incidence.id)"
                          class="btn btn-link text-danger text-gradient px-3 m-0">
                          <i class="far fa-trash-alt me-2" aria-hidden="true"></i>
                          Eliminar
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Transition name="slide-fade">
      <div class="col-md-4 col-sm-12" v-if="markers.length > 0">
        <div class="card">
          <div class="card-body">
            <GMapMap :center="center" :zoom="12" style="width: 100%; height: 40vh">
              <GMapMarker :key="index" v-for="(m, index) in markers" :position="m.position"
                @click="center = m.position" />
            </GMapMap>
            <div class="d-flex justify-content-around">
              <div class="d-flex justify-content-center">
                <button class="btn btn-link text-dark m-0" @click="markers = []"><i class="fa fa-times"></i> Cerrar
                  mapa</button>
              </div>
              <div class="d-flex justify-content-center">
                <button class="btn btn-link text-dark m-0" @click.prevent="abrirEnlace(markers[0].position)">
                  Abrir con Google
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Transition>


  </div>
</template>


<script>
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-dt/css/jquery.dataTables.css';

// import 'datatables.net-responsive';

export default {
  name: "incidencias-table",
  props: {
    incidences: {
      type: Array,
      request: true,
    },
  },
  data() {
    return {
      selectedMarker: null,
      markers: [],
      center: { lat: 22.119417, lng: -101.029418 }, //coordendas iniciales del mapa
    }
  },
  mounted() {
    this.incidences.map(obj => {
      obj.openMenu = false;
    })
    $('#my-table-incidences').DataTable({
      order: [[2, 'desc']],
      pageLength: 50,
      lengthChange: false,
      columnDefs: [{
        targets: 2,
        orderData: 2,
        type: 'string'
      },
      { targets: [0, 3, 4, 5], orderable: false }
      ],
      language: {
        url: '//cdn.datatables.net/plug-ins/1.10.25/i18n/Spanish.json'
      }
    });
  },
  methods: {
    openDrop(id) {
      let a = this.incidences.find(obj => obj.id == id);
      let band = a.openMenu;
      this.incidences.map(obj => {
        obj.openMenu = false;
      })
      a.openMenu = !band;
    },
    openLocation(id) {
      this.center = {};
      this.markers = [];
      let incidence = this.incidences.find(obj => obj.id == id);
      if (incidence) {
        this.markers.push({ position: { lat: parseFloat(incidence.lat), lng: parseFloat(incidence.lng) } });
        this.center = { lat: parseFloat(incidence.lat), lng: parseFloat(incidence.lng) };
      }
    },
    changeStatus(id, status) {
      // DESCOMENTAR CUANDO SE TENGA LA RUTA
      this.plain
        .patch(`/incidences/${id}`, { incidence: { status } })
        .then(() => {
          //console.log(response)
          this.showAlert()
        })
        .catch((error) => {
          console.log("Error al actualizar el estatus del siniestro", error);
        });
    },
    dateSort(date) {
      const fechaJavascript = new Date(date);
      const day = fechaJavascript.getDate();
      const month = (fechaJavascript.getMonth() + 1).toString().length === 1 ? `0${fechaJavascript.getMonth() + 1}` : fechaJavascript.getMonth() + 1;
      const year = fechaJavascript.getFullYear();
      return `${day}-${month}-${year}`
    },
    timeSort(date) {
      const fechaJavascript = new Date(date);
      return `${fechaJavascript.getHours()}:${fechaJavascript.getMinutes()}`;
    },
    deleteIncidence(incidenceID) {
      this.plain
        .delete(`/incidences/${incidenceID}`)
        .then(() => {
          this.$parent.deleteItemIncidence(incidenceID)
          // console.log("INCIDENCIA eliminado correctamente");
          // console.log(response.data);
        })
        .catch((error) => {
          console.log("Error al eliminar INCIDENCIAS", error);
        });
    },
    abrirEnlace(marker) {
      window.open(`https://www.google.com/maps/search/?api=1&query=${marker.lat},${marker.lng}`, "_blank");
    },
    showAlert() {
      this.$parent.refreshIncidences()
      $('#my-table-incidences').DataTable().destroy();
      $('#my-table-incidences').DataTable({
        order: [[2, 'desc']],
        pageLength: 50,
        lengthChange: false,
        columnDefs: [{
          targets: 2,
          orderData: 2,
          type: 'string'
        },
        { targets: [0, 3, 4, 5], orderable: false }
        ],
        language: {
          url: '//cdn.datatables.net/plug-ins/1.10.25/i18n/Spanish.json'
        }
      });
    },
    showAlertDelete(incidenceID) {
      this.$swal.fire({
        title: '¿Está seguro?',
        text: "¡No podrás revertir esto!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Aceptar',
        cancelButtonText: 'Cancelar',
      }).then((result) => {
        if (result.isConfirmed) {
          this.deleteIncidence(incidenceID);
          this.$swal.fire(
            '¡Eliminado!',
            'La Incidencia ha sido eliminada.',
          )
        }
      })
    }
  },
};
</script>
